import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faClock,
  faCheck,
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";

library.add(faUser, faClock, faCheck, faCircleCheck, faCircleXmark);

const app = createApp(App);
app.component("font-awesome-icon", FontAwesomeIcon);

const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "tc",
  messages: {
    tc: {
      pageTitle: "美麗華集團電子郵件驗證",
      message: {
        title: "電子郵件驗證",
        verifying: "正在驗證您的電子郵件，請稍候...",
        success: "您的電郵地址已成功驗證",
      },
      error: {
        alreadyVerified: "此電郵已被驗證。",
        expiredCode: "很抱歉，此連結已失效，請重新驗證。"
      },
      backToEshop: "返回首頁"
    },
    sc: {
      pageTitle: "美丽华集团电子邮件验证",
      message: {
        title: "电子邮件验证",
        verifying: "正在验证您的电子邮件，请稍候...",
        success: "您的电邮地址已成功验证",
      },
      error: {
        alreadyVerified: "此电邮已被验证。",
        expiredCode: "很抱歉，此连结已失效，请重新验证。"
      },
      backToEshop: "返回首页"
    },
    en: {
      pageTitle: "Miramar Group Email Verification",
      message: {
        title: "Email Verification",
        verifying: "Verifying your email, please wait...",
        success: "Your email address has been verified.",
      },
      error: {
        alreadyVerified: "This email has already been verified.",
        expiredCode: "Sorry, the verification link is expired, please submit your request again."
      },
      backToEshop: "Back to Homepage"
    },
  },
});

// Mount the app to the DOM
app.use(i18n);
app.mount("#app");
